import * as React from 'react';


const Footer = () => {
  return <div style={{ width: '100%' }}>(c) lennart@takanen.eu</div>;
};

export default Footer;
